// EmployeeListItemVerticalEditable.tsx (Label-Value-Pair layout with old + editable new values)
import React from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableHead,
  TableBody,
  Paper
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectEndorsmentFormData,
  selectPolicyDetails,
  updateEndorsementFormData
} from 'src/features/rfqDataSlice';
import moment from 'moment';

function EmployeeListItemVerticalEditable({ sumInsuredData, groupDetails, productId }) {
  const dispatch = useDispatch();
  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const policyDetails = useSelector(selectPolicyDetails);

  const sectionId = sumInsuredData?.id;
  const groupId = groupDetails?.id;

  const selectedHeads = endorsementFormData?.sumInsuredSectionData?.[sectionId]?.groups?.[groupId]?.sumInsuredSelectedHeads || [];
  const tableListDatas = endorsementFormData?.sumInsuredSectionData?.[sectionId]?.groups?.[groupId]?.sumInsuredEntry || [];

  const oldRow = policyDetails?.policySumInsuredSections.filter(item => item.id == sectionId)?.[0] || {};
  const newRow = tableListDatas?.[0] || {};

  const handleChange = (attr, value) => {
    const updatedRow = { ...newRow, [attr]: value, savedStatus: false, actionType: 'update' };
    const updatedList = [updatedRow];

    const updatedGroup = {
      ...endorsementFormData.sumInsuredSectionData[sectionId].groups[groupId],
      sumInsuredEntry: updatedList
    };

    const updatedSection = {
      ...endorsementFormData.sumInsuredSectionData[sectionId],
      groups: {
        ...endorsementFormData.sumInsuredSectionData[sectionId].groups,
        [groupId]: updatedGroup
      }
    };

    dispatch(updateEndorsementFormData({
      sumInsuredSectionData: {
        ...endorsementFormData.sumInsuredSectionData,
        [sectionId]: updatedSection
      }
    }));
  };

  const renderInput = (attr, value, head) => {
    if (['dob', 'dateOfCoverage', 'dobOfMamber'].includes(attr)) {
      return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>

          <DatePicker
            views={['year', 'month', 'day']}
            inputFormat="dd-MM-yyyy"
            value={value ? moment(value, "DD-MM-YYYY").toDate() : null}
            onChange={(val) => {
              const formattedDate = val ? moment(val).format("DD-MM-YYYY") : null;
              handleChange(attr, formattedDate);
            }}
            maxDate={new Date()}
            renderInput={(params) => (
              <TextField {...params} size="small" fullWidth />
            )}
          />
        </LocalizationProvider>
      );
    }

    if (attr === 'gender') {
      return (
        <FormControl fullWidth size="small">
          <InputLabel>{head.title || head.sumInsuredHeader.title}</InputLabel>
          <Select
            style={{ minWidth: '180px' }}
            label="Gender"
            value={value || ''}
            onChange={(e) => handleChange(attr, e.target.value)}
          >
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </Select>
        </FormControl>
      );
    }

    if (attr === 'relationshipForTailormade') {
      return (
        <FormControl fullWidth size="small">
          <InputLabel>{head.title || head.sumInsuredHeader.title}</InputLabel>
          <Select
            style={{ minWidth: '180px' }}
            label="relationshipForTailormade"
            value={value || ''}
            onChange={(e) => handleChange(attr, e.target.value)}
          >
            <MenuItem value={'Self'}>Self</MenuItem>
            <MenuItem value={'Spouse'}>Spouse</MenuItem>
            <MenuItem value={'Child 1'}>Child 1</MenuItem>
            <MenuItem value={'Child 2'}>Child 2 </MenuItem>
            <MenuItem value={'Child 3'}>Child 3 </MenuItem>
            <MenuItem value={'Child 4'}>Child 4 </MenuItem>
            <MenuItem value={'Child 5'}>Child 5 </MenuItem>
            <MenuItem value={'Child 6'}>Child 6 </MenuItem>
            <MenuItem value={'Child 7'}>Child 7 </MenuItem>
            <MenuItem value={'Father'}>Father</MenuItem>
            <MenuItem value={'Mother'}>Mother</MenuItem>
            <MenuItem value={'Father-in-law'}>Father-in-law</MenuItem>
            <MenuItem value={'Mother-in-law'}>Mother-in-law</MenuItem>
            <MenuItem value={'Brother'}>Brother</MenuItem>
            <MenuItem value={'Sister'}>Sister</MenuItem>
          </Select>
        </FormControl>
      );
    }

    return (
      <TextField
        size="small"
        fullWidth
        type={['age', 'sumInsured', 'premium', 'topupSI'].includes(attr) ? 'number' : 'text'}
        value={value || ''}
        onChange={(e) => handleChange(attr, e.target.value)}
      />
    );
  };

  const formatValue = (attr, value) => {
    if (!value) return 'N/A';
    if (['dob', 'dateOfCoverage', 'dobOfMamber'].includes(attr)) {
      return new Date(value).toLocaleDateString('en-GB');
    }
    return Array.isArray(value) ? value.join(', ') : value;
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>Field</strong></TableCell>
            <TableCell sx={{ color: 'red' }}><strong>Old Value</strong></TableCell>
            <TableCell sx={{ color: 'green' }}><strong>New Value</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sumInsuredData?.sumInsuredHeaderSorted?.map((head) => {
            const attr = head.sumInsuredHeader.attribute;
            if (!selectedHeads.includes(attr)) return null;
            const label = head.title || head.sumInsuredHeader.title;
            const oldVal = oldRow['employeeList']?.[0]?.[attr];
            const newVal = newRow[attr];
            return (
              <TableRow key={attr}>
                <TableCell style={{ width: '470px' }}>{label}</TableCell>
                <TableCell style={{ width: '450px' }} sx={{ color: oldVal !== newVal ? 'red' : 'inherit' }}>{formatValue(attr, oldVal)}</TableCell>
                <TableCell>{renderInput(attr, newVal, head)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default EmployeeListItemVerticalEditable;
